import type {DoppeTemplateInstance} from "../../doppe-sdk";
import {dopeActionButtonTemplateResolveProps} from "../../doppe-sdk";
import {DoppeActionButtonTemplateIds} from "./doppe-templates";
import {
    DopeStandardActionButtonSkin,
    DoppeStandardActionButtonHoverAnimation,
    DoppeStandardActionButtonTemplateMetadata
} from "../../components/doppe-action-button-templates/doppe-standard-action-button-template/doppe-standard-action-button-template.metadata";
import {BymoPageActionRoundness} from "../bymo-pages/bymo-page-action-roundness";

export function doppeActionButtonTemplateInstanceHasShadow (
    actionButtonTemplateInstance: DoppeTemplateInstance
) {
    if (actionButtonTemplateInstance.templateId === DoppeActionButtonTemplateIds.Standard) {

        const templateProps = dopeActionButtonTemplateResolveProps(
            DoppeStandardActionButtonTemplateMetadata,
            actionButtonTemplateInstance.templateProps)

        switch (templateProps.skin) {
            case DopeStandardActionButtonSkin.HardShadow: return true;
            default: return false;
        }
    }

    return false;
}

export function doppeActionButtonTemplateInstanceHasTransparentBackground (
    actionButtonTemplateInstance: DoppeTemplateInstance
) {
    if (actionButtonTemplateInstance.templateId === DoppeActionButtonTemplateIds.Standard) {
        const templateProps = dopeActionButtonTemplateResolveProps(
            DoppeStandardActionButtonTemplateMetadata,
            actionButtonTemplateInstance.templateProps)

        switch (templateProps.skin) {
            case DopeStandardActionButtonSkin.Inverted: return true;
            default: return false;
        }
    }

    return false;
}

export function doppeActionButtonTemplateInstanceIsPremium (
    actionButtonTemplateInstance: DoppeTemplateInstance
) {
    if (actionButtonTemplateInstance.templateId === DoppeActionButtonTemplateIds.Standard) {
        const templateProps = dopeActionButtonTemplateResolveProps(
            DoppeStandardActionButtonTemplateMetadata,
            actionButtonTemplateInstance.templateProps)

        switch (templateProps.skin) {
            case DopeStandardActionButtonSkin.Gradient:
            case DopeStandardActionButtonSkin.Glass: {
                return true;
            }
            default: return false;
        }
    }

    return false;
}

export function doppeActionButtonTemplateGetDefault () {
    return {
        templateId: DoppeActionButtonTemplateIds.Standard,
        templateProps: {
            roundness: 0,
            skin: DopeStandardActionButtonSkin.Standard,
            hoverAnimation: DoppeStandardActionButtonHoverAnimation.None
        }
    }
}

/**
 * Default action-button template instance used to back the social-links Roundness
 * picker on new pages. The Roundness defaults to the maximum option ({@link
 * BymoPageActionRoundness.Pixels25}) — at the social-links button-chrome sizes
 * (34 / 44 / 60 px) this radius reads as a full circle/pill, which is the
 * preferred default visual for social icon buttons.
 *
 * The stored `skin` value is intentionally ignored at render time — the
 * rendered skin comes from `socialLinksButtonStyle`.
 */
export function doppeActionButtonTemplateGetSocialLinksDefault () {
    return {
        templateId: DoppeActionButtonTemplateIds.Standard,
        templateProps: {
            roundness: BymoPageActionRoundness.Pixels25,
            skin: DopeStandardActionButtonSkin.Standard,
            hoverAnimation: DoppeStandardActionButtonHoverAnimation.None
        }
    }
}